import React from 'react';
import { CheckCircle2, AlertTriangle, Circle } from 'lucide-react';
import StatusBadge from '../data/StatusBadge';

const stateIcon = {
  ok: CheckCircle2,
  warn: AlertTriangle,
  pending: Circle,
};

const stateTone = {
  ok: 'ok',
  warn: 'warn',
  pending: 'neutral',
};

const stateText = {
  ok: 'OK',
  warn: 'Peringatan',
  pending: 'Belum',
};

export default function InlineStatusRow({ items = [], className = '' }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {items.map((item) => {
        const Icon = stateIcon[item.state] || Circle;
        const tone = stateTone[item.state] || 'neutral';
        return (
          <div key={item.key} className="cc-tonal-panel-soft flex items-center justify-between px-3 py-2">
            <span className="text-xs font-semibold uppercase tracking-[0.08em] text-[#d5e4f4]">{item.label}</span>
            <div className="inline-flex items-center gap-2">
              <Icon className="h-3.5 w-3.5 text-[#8ea3bd]" />
              <StatusBadge tone={tone}>{item.text || stateText[item.state] || 'Belum'}</StatusBadge>
            </div>
          </div>
        );
      })}
    </div>
  );
}
